import { IApplicationState } from '../../types/redux';
import { IEstimationState } from '../../types/redux/estimation';
import { EDealType } from '../../types/dealType';

export const selectEstimationByDealType =
  (dealType: EDealType) =>
  (state: IApplicationState): IEstimationState[EDealType.Sale] | IEstimationState[EDealType.Rent] => {
    const { estimation } = state;

    return estimation[dealType];
  };
